import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

const CheckboxOption = ({ innerRef, innerProps, isSelected, label }) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }}
  >
    <input
      type="checkbox"
      checked={isSelected}
      onChange={() => null}
      style={{ marginRight: 8, height: '16px', width: '16px' }}
    />
    <label className="tw-text-[#526d7a] tw-text-[0.8125rem]">{label}</label>
  </div>
);

const AgesMultiSelectCheckbox = ({ control, agesOptions }) => {
  return (
    <Controller
      name="ages"
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <Select
            options={agesOptions}
            isMulti
            value={
              agesOptions?.length > 0 && value?.length > 0
                ? agesOptions.filter((option) => value.includes(option.value))
                : []
            }
            onChange={(selected) => {
              onChange({
                target: {
                  name: 'ages',
                  value: selected ? selected.map((option) => option.value) : [],
                },
              });
            }}
            isClearable={false}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option: CheckboxOption }}
            placeholder="Select ages"
            isSearchable={false}
            styles={{
              control: (base) => ({ ...base, borderColor: '#ced4da' }),
              option: (base) => ({ ...base, padding: 0 }),
              placeholder: (base) => ({
                ...base,
                fontSize: '0.8125rem',
                color: '#526d7a',
              }),
            }}
          />
        );
      }}
    />
  );
};

export default AgesMultiSelectCheckbox;
